<template>
  <div>

    <div class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#"
            @click="addAccount">
        <i class="fa fa-plus"></i> Add Account
      </a>
    </div>

    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="rowClick"
              id="affiliateAccountsTable" class="table-striped" 
              :data="affiliateAccounts" :row-class-name="''">

      <el-table-column prop="id" label="ID" width="100"/>

      <el-table-column label="Date created" width="140">
        <template slot-scope="{row}">
          {{ displayDate(row.dateCreated) }}
        </template>
      </el-table-column>

      <el-table-column prop="type" label="Type" width="70"/>

      <el-table-column label="Card ID" width="130">
        <template slot-scope="{row}">
          {{ row && row.paymentCards && row.paymentCards[0] ? row.paymentCards[0].id || '-' : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="Balance" width="80">
        <template slot-scope="{row}">
          <!-- <span> {{ getPaymentCardBalance(row) }} <a v-if="row.paymentCards && row.paymentCards[0]"
                                                     v-tooltip.top-center="'Load card'"
                                                     @click="loadCard(row.id)"
                                                     class="btn-link d-none btn-success showOnHover">
                                                    <i class="fas fa-plus fa-xs"/>
                                                  </a>
                                                  <a v-if="row.paymentCards && row.paymentCards[0]"
                                                     v-tooltip.top-center="'Unload card'"
                                                     @click="unloadCard(row.id)"
                                                     class="btn-link d-none btn-danger showOnHover">
                                                    <i class="fas fa-minus ml-1 fa-xs"/>
                                                  </a>
          </span> -->
          <a v-if="row.paymentCards && row.paymentCards[0]"
             @click="changeBalance(row)"
             class="btn-link"
             v-tooltip.center-top="'Load / Unload card'">
              {{ getPaymentCardBalance(row) }} 
          </a>
          <template v-else>
            {{ getPaymentCardBalance(row) }} 
          </template>
        </template>
      </el-table-column>

      <el-table-column label="Name">
        <template slot-scope="{row}">
          <div v-tooltip.top-center="addressTooltip(row)">
            {{ getAffiliate(row.id).firstName + ' ' + getAffiliate(row.id).lastName }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Company">
        <template slot-scope="{row}">
          {{ getAffiliateCompanyName(row) }}
        </template>
      </el-table-column>

      <el-table-column label="User status" width="100">
        <template slot-scope="{row}">
          {{ getAffiliate(row.id).status || '-' }}
        </template>
      </el-table-column>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <!-- !!! we need the attribute name to be all lower case !! -->
          <div :affiliateAccountId="row.id"/>  <!-- this is for the onHover method to find the right row onHover -->
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import utils from '../../utils'
import NProgress from 'nprogress'
export default {
    name: 'Affiliate-Accounts-Table',
    props: {
      // hidePosition:       {type: Boolean, default: false},
      // hideCompany:        {type: Boolean, default: false},
      // hideLeadsReceived:  {type: Boolean, default: false},
      // hideLeadsClosed:    {type: Boolean, default: false},
      // hideLeads:          {type: Boolean, default: false},
      // hidePayouts:        {type: Boolean, default: false},
      // hideCloseRate:      {type: Boolean, default: false},
      // forCompany:         {type: Object, default: null}
    },
    mounted () {
      // NProgress.start()
      this.$store.dispatch('fetchBaseData')
    },
    computed: {
      affiliateAccounts () {
        return this.$store.getters.affiliateAccounts || []
      },
    },
    methods: {
      displayDate (date) {
        return utils.dateToString(date)
        // return '-'
      },
      addAccount () {
        alert(`Not yet implemented`)
      },
      getAffiliate (id) {
        return this.$store.getters.users.find(u => u.type == 'affiliate' && u.id == id) ||  {}
      },
      getAffiliateCardId (affiliateId) {
        const cards = this.getAffiliate(affiliateId).paymentCards
        // alert('cards = ', cards)
        if (cards && cards[0])
          return cards[0].id
        else
          return '-'
      },
      getAffiliateCompanyName (affiliateAccount) {
        const company = this.$store.getters.affiliateCompanies.find(c => c.id == affiliateAccount.affiliateCompanyId)
        // console.log('company = ', company)
        return company && company.profile ? company.profile.companyName || '-' : '-'
      },
      addressTooltip (row) {
        const affiliate = this.getAffiliate(row.id)
        if (!affiliate) return ''
        const a = affiliate.address
        if (!a) return ''
        return a.addressLine1 + '<br>'
             + (a.addressLine2 ? a.addressLine2 + '<br>' : '')
             + `${a.city} ${a.state}, ${a.postalCode}<br>`
             + a.country
      },
      
      getPaymentCardBalance (account) {
        if (!account || !account.paymentCards || !account.paymentCards[0]) return '-'
        const card = account.paymentCards[0]
        const found = this.$store.getters.paymentCards.find(c => c.id == card.id && c.paymentCardProviderId == card.paymentCardProviderId)
        if (!found) return '-'
        return `$${found.balance}` || '-'
      },
      
      changeBalance (account) {
        if (!account || !account.paymentCards || !account.paymentCards[0]) return
        const card = account.paymentCards[0]
        this.$store.dispatch('openModal', { name: 'Payment Card Balance',
                                            object: { id: card.id,
                                                      paymentCardProviderId: card.paymentCardProviderId,
                                                      affiliateAccountId: account.id,
                                                      paymentCardBalance: this.getPaymentCardBalance(account),
                                                      loadAmount: 0,
                                                      unloadAmount: 0
                                            }
                                          }
        )
      },



      // rowClasses ({row, rowIndex}) {
      //   return row.archived?'archivedTableRow clickableRow':'clickableRow'
      // },
      rowHover(row, column, cell, event) {
        // We show all buttons of class .showOnHover
        var rows = $('#affiliateAccountsTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var foundRow = JSON.stringify($(rows[i]).html().indexOf('affiliateaccountid="'+row.id+'"')) > -1
          // console.log('id = ', row.id)
          // console.log('foundRow = ', foundRow)
          var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
          if (foundRow && !archivedRow) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).removeClass('d-none')
            }
            break
          }
        }
      },
      rowHoverLeave (row, column, cell, event) {
        // We hide all buttons of class .showOnHover
        var rows = $('#affiliateAccountsTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var index = JSON.stringify($(rows[i]).html().indexOf('affiliateaccountid="'+row.id+'"'))
          if (index > -1) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).addClass('d-none')
            }
            break
          }
        }
      },
      rowClick (row, column, event) {
        // We check to see if the click happened on an icon button
        // var match = JSON.stringify(event.toElement.classList.value).match(/fa[rsdl]{0,1}\sfa-/i)
        var path = event.path || event.composedPath() // 2nd one if for Firefox
        var match = JSON.stringify(path[0].className).match(/fa[rsdl]{0,1}\sfa-/i)
        if (match && match.index > -1) {
          // icon button, we ignore row click
        } else {
          //console.log('row click')
          // this.editAffiliate(row)
        }
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>